import { Component, OnInit } from "@angular/core";
import { LanguagesService } from "src/app/services/languages.service";
import { ToastrService } from "ngx-toastr";
import { RecordCompanyService } from "src/app/services/record-company.service";
import { ValidationService } from "src/app/services/validation.services";
import { MessageService } from "src/app/services/message.service";
import { ConfigurationService } from "src/app/services/configuration.service";
import { AttachmentsService } from "src/app/services/attachments.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UsersService } from "src/app/services/user.service";
import { DatePipe } from "@angular/common";
import {
  ConfigurazioneCaptcha,
  Validazioni,
  NazioniResponse,
  DocumentiResponse,
} from "src/app/interfaces/utilities";
import { ReCaptcha2Component } from "ngx-captcha";
import { FormlyFormOptions, FormlyFieldConfig } from "@ngx-formly/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { Utente } from "src/app/interfaces/user";
import { Observable, forkJoin } from "rxjs";
import {
  checkResponse,
  fileToBase64,
  substrBase64,
  checkFormValidity,
} from "src/app/utilities/utilities";
import { map } from "rxjs/operators";
import {
  validator,
  errorMessage,
  getValidatorPattern,
} from "src/app/utilities/validators";
import { formArrayNameProvider } from "@angular/forms/src/directives/reactive_directives/form_group_name";
import { Allegato } from "src/app/interfaces/record-company";
import { ModalGdprService } from "src/app/services/modal-gdpr.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import * as moment from "moment";

@Component({
  selector: "app-record-company-rl-registration",
  templateUrl: "./record-company-rl-registration.component.html",
  styles: [],
})
export class RecordCompanyRLRegistrationComponent implements OnInit {
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[];
  form = new FormGroup({});
  model: any = {
    ignoreCaptcha: false,
    casaDiscografica: {},
    utente: {},
  };

  validationList: Validazioni[];
  listaNazioni = [];
  listaDocumenti = [];
  LABEL_ATTACH = this.languageService.getValue("bc_attc_ed");
  captchaConfiguration: ConfigurazioneCaptcha;
  private googlereCaptcha: ReCaptcha2Component;

  constructor(
    private languageService: LanguagesService,
    private toastrService: ToastrService,
    private recordCompanyService: RecordCompanyService,
    private userService: UsersService,
    public datepipe: DatePipe,
    private validationsService: ValidationService,
    private messageService: MessageService,
    private configurationsService: ConfigurationService,
    private attachmentsService: AttachmentsService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private modalGDPRService: ModalGdprService,
    private modalService: BsModalService
  ) {
    this.validationList = this.validationsService.validatorsList.value;
  }
  bsModalRef: BsModalRef;

  ngOnInit() {
    this.messageService.reportMessage(
      this.languageService.getValue("record_company_registration")
    );
    this.captchaConfiguration = this.configurationsService.configuration.value;
    forkJoin(this.getNations(), this.getDocumentTypes()).subscribe((data) => {
      this.validationList = this.validationsService.validatorsList.value;

      this.listaNazioni = [];
      data[0].nazioni.forEach((nazione) => {
        this.listaNazioni.push({
          label: nazione.nome,
          value: nazione.id,
        });
      });

      this.listaDocumenti = [];
      data[1].documenti.forEach((documento) => {
        this.listaDocumenti.push({
          label: documento.nome,
          value: documento.id,
        });
      });

      this.init();
    });
  }

  init() {
    this.model.casaDiscografica = {
      nome: "",
      siglaOriginale: "",
      sigla: "",
      indirizzo: "",
      telefono: "",
      telefonoAlternativo: "",
      citta: "",
      provincia: "",
      estero: false,
      idNazione: "",
      partitaIVA: "",
      numeroCanali: 1,
      allegati: null,
    };

    this.model.utente = new Utente();
    this.createFields();
  }

  getNations(): Observable<NazioniResponse> {
    return this.recordCompanyService
      .getNations()
      .pipe(
        map((response: NazioniResponse) =>
          checkResponse(response, this.toastrService)
        )
      );
  }

  getDocumentTypes(): Observable<DocumentiResponse> {
    return this.userService
      .getDocumentTypes()
      .pipe(
        map((response: DocumentiResponse) =>
          checkResponse(response, this.toastrService)
        )
      );
  }

  //Utility for the attachment creation
  onDetectedDocument(event: any, counter) {
    if (event.target.files.length > 0) {
      this.model.utente.allegati[counter].nomeFile = event.target.files[0].name;
      this.model.utente.allegati[counter].tipoAllegato =
        event.target.files[0].type;
      fileToBase64(event.target.files[0]).then((result) => {
        this.model.utente.allegati[counter].urlAllegato = substrBase64(result);
      });
      let attachmentName = (event.target.files[0].name as string).split(".")[0];
      this.model.utente.allegati[counter].nomeAllegato = attachmentName;
    }
  }

  onDetectedLogo(event: any, counter) {
    let casaDiscografica = this.form.controls["casaDiscografica"] as FormGroup;
    let logo = casaDiscografica.controls["logo"];
    if (event.target.files.length > 0) {
      if (
        !event.target.files[0].type ||
        event.target.files[0].type.length == 0
      ) {
        logo.setErrors({
          mediaTypeNotRecognized: true,
        });
        logo.markAsTouched({
          onlySelf: true,
        });
        this.model.casaDiscografica.allegati = null;
        return;
      }
      if (
        !this.model.casaDiscografica.allegati ||
        this.model.casaDiscografica.allegati == null
      ) {
        this.model.casaDiscografica.allegati = new Array();
        this.model.casaDiscografica.allegati.push({
          nomeFile: "",
          tipoAllegato: "1",
          mediaTipoAllegato: "",
          base64Allegato: "",
          nomeAllegato: "",
        } as Allegato);
      }
      this.model.casaDiscografica.allegati[counter].nomeFile =
        event.target.files[0].name;
      this.model.casaDiscografica.allegati[counter].mediaTipoAllegato =
        event.target.files[0].type;
      fileToBase64(event.target.files[0]).then((result) => {
        this.model.casaDiscografica.allegati[counter].urlAllegato =
          substrBase64(result);
        this.model.casaDiscografica.allegati[counter].base64Allegato =
          substrBase64(result);
      });
      let attachmentName = (event.target.files[0].name as string).split(".")[0];
      this.model.casaDiscografica.allegati[counter].nomeAllegato =
        attachmentName;
    }
  }

  createFields() {
    this.fields = [
      {
        key: "casaDiscografica",
        wrappers: ["panel"],
        templateOptions: {
          label: this.languageService.getValue("rc_record_new"),
        },
        fieldGroup: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-md-6",
                key: "nome",
                type: "sanremo-input-lite",
                templateOptions: {
                  required: true,
                  type: "text",
                  label: this.languageService.getValue("bc_form_nome_completo"),
                  placeholder: this.languageService.getValue(
                    "bc_form_nome_completo"
                  ),
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-2 mt-4",
                key: "estero",
                type: "sanremo-checkbox",
                defaultValue: false,
                templateOptions: {
                  label: this.languageService.getValue("ed_pr_estero"),
                },
                validators: {
                  estero: {
                    expression: (c) => {
                      let casaDiscografica = this.form.controls[
                        "casaDiscografica"
                      ] as FormGroup;
                      let partitaIVA = casaDiscografica.controls["partitaIVA"];
                      let provincia = casaDiscografica.controls["provincia"];
                      let regex: RegExp = getValidatorPattern(
                        "partita_IVA",
                        this.validationList
                      );

                      if (c.value == false) {
                        if (partitaIVA) {
                          if (regex)
                            partitaIVA.setValidators([
                              Validators.pattern(regex),
                              Validators.required,
                            ]);
                          else partitaIVA.setValidators([Validators.required]);

                          partitaIVA.updateValueAndValidity();
                        }

                        if (provincia) {
                          provincia.setValidators([Validators.required]);
                          provincia.updateValueAndValidity();
                        }
                      } else {
                        if (partitaIVA) {
                          if (regex)
                            partitaIVA.setValidators([
                              Validators.pattern(regex),
                            ]);
                          else partitaIVA.clearValidators();
                          partitaIVA.updateValueAndValidity();
                        }

                        if (provincia) {
                          provincia.clearValidators();
                          provincia.updateValueAndValidity();
                        }
                      }
                      return true;
                    },
                  },
                },
              },
            ],
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-md-6 mt-2",
                key: "sigla",
                type: "sanremo-input-lite",
                templateOptions: {
                  type: "text",
                  label: this.languageService.getValue("bc_form_acronimo"),
                  placeholder:
                    this.languageService.getValue("bc_form_acronimo"),
                  required: true,
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-6 mt-2",
                key: "telefono",
                type: "input",
                templateOptions: {
                  label: this.languageService.getValue("telefono_principale"),
                  placeholder: this.languageService.getValue(
                    "telefono_principale"
                  ),
                  required: true,
                },
                validators: {
                  cell: {
                    expression: (c) =>
                      validator("cell", c.value, this.validationList),
                    message: (error, field: FormlyFieldConfig) =>
                      errorMessage(
                        field.formControl.value,
                        "cell",
                        this.languageService
                      ),
                  },
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-6",
                key: "telefonoAlternativo",
                type: "input",
                templateOptions: {
                  label: this.languageService.getValue("telefono_alternativo"),
                  placeholder: this.languageService.getValue(
                    "telefono_alternativo"
                  ),
                },
                validators: {
                  cell: {
                    expression: (c) =>
                      validator("cell", c.value, this.validationList),
                    message: (error, field: FormlyFieldConfig) =>
                      errorMessage(
                        field.formControl.value,
                        "cell",
                        this.languageService
                      ),
                  },
                },
              },
              {
                className: "col-md-6",
                key: "idNazione",
                type: "select",
                templateOptions: {
                  required: true,
                  label: this.languageService.getValue(
                    "nazione_residenza_ufficio"
                  ),
                  placeholder:
                    this.languageService.getValue("nazione_residenza"),
                  options: this.listaNazioni,
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },

              {
                className: "col-md-6",
                key: "indirizzo",
                type: "sanremo-input-lite",
                templateOptions: {
                  required: true,
                  type: "text",
                  label: this.languageService.getValue("indirizzo"),
                  placeholder: this.languageService.getValue("indirizzo"),
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-md-6",
                key: "citta",
                type: "sanremo-input-lite",
                templateOptions: {
                  required: true,
                  type: "text",
                  label: this.languageService.getValue("citta"),
                  placeholder: this.languageService.getValue("citta"),
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-md-6 mt-2",
                key: "provincia",
                type: "sanremo-input-lite",
                templateOptions: {
                  type: "text",
                  label: this.languageService.getValue("provincia"),
                  placeholder: this.languageService.getValue("provincia"),
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },

              {
                className: "col-6 mt-2",
                key: "partitaIVA",
                type: "input",
                templateOptions: {
                  label: this.languageService.getValue("partita_IVA"),
                  placeholder: this.languageService.getValue("partita_IVA"),
                },
                modelOptions: {
                  updateOn: "blur",
                },
                validators: {
                  partitaIVA: {
                    expression: (c) =>
                      validator("partita_IVA", c.value, this.validationList),
                    message: (error, field: FormlyFieldConfig) =>
                      errorMessage(
                        field.formControl.value,
                        "partita_IVA",
                        this.languageService
                      ),
                  },
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                    pattern: this.languageService.getValue("invalid_VATnumber"),
                  },
                },
              },
            ],
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-md-6",
                key: "logo",
                type: "file-input",
                templateOptions: {
                  type: "file",
                  label: this.languageService.getValue("logo"),
                  required: false,
                  callback: (event) => this.onDetectedLogo(event, 0),
                  fileName: null,
                  reset: (x) => this.resetLogo(),
                  attributes: { maxSize: 5, extraDesc: "max 5MB" },
                },
                wrappers: ["form-field", "file-wrapper-lite"],
                // validators: {
                //   fileValidator: {
                //     expression: (c) => c.value == null || c.value.length == 0,
                //     message: {"required" : true}
                //   }
                // },
                validation: {
                  messages: {
                    mediaTypeNotRecognized: this.languageService.getValue(
                      "tipo_allegato_non_riconosciuto"
                    ),
                  },
                },
              }
            ],
          },

          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-md-6 my-auto",
                key: "informativa_privacy",
                type: "sanremo-checkbox",
                templateOptions: {
                  label: this.languageService.getValue("informativa_privacy"),
                  pattern: 'true',
                  required: true,
                  default: false,
                  indeterminate: false
                },
                validation: {
                  messages: {
                    pattern: this.languageService.getValue("campo_obbligatorio"),
                    required: this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
            ],
          },
        ],
      },
      {
        key: "utente",
        wrappers: ["panel"],
        templateOptions: {
          label: this.languageService.getValue("rappresentante_legale"),
        },
        fieldGroup: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-2",
                type: "select",
                defaultValue: "Mr.",
                key: "titolo",
                templateOptions: {
                  label: this.languageService.getValue("titolo_candidatura"),
                  multiple: false,
                  options: [
                    { label: "Mr.", value: "Mr." },
                    { label: "Mrs.", value: "Mrs." },
                  ],
                },
              },
              {
                className: "col-5",
                type: "sanremo-input-lite",
                key: "nome",
                templateOptions: {
                  label: this.languageService.getValue("filtro_nome"),
                  placeholder: this.languageService.getValue("filtro_nome"),
                  required: true,
                },
                modelOptions: {
                  updateOn: "blur",
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-5",
                type: "sanremo-input-lite",
                key: "cognome",
                templateOptions: {
                  label: this.languageService.getValue("filtro_cognome"),
                  placeholder: this.languageService.getValue("filtro_cognome"),
                  required: true,
                },
                modelOptions: {
                  updateOn: "blur",
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
            ],
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-6",
                type: "input",
                key: "email",
                templateOptions: {
                  label: this.languageService.getValue("email"),
                  placeholder: this.languageService.getValue("email"),
                  required: true,
                },
                modelOptions: {
                  updateOn: "blur",
                },
                validators: {
                  email: {
                    expression: (c) =>
                      validator("email", c.value, this.validationList),
                    message: (error, field: FormlyFieldConfig) =>
                      errorMessage(
                        field.formControl.value,
                        "email",
                        this.languageService
                      ),
                  },
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-6",
                type: "input",
                key: "telefono",
                templateOptions: {
                  label: this.languageService.getValue("cell"),
                  placeholder: this.languageService.getValue("cell"),
                  required: true,
                },
                modelOptions: {
                  updateOn: "blur",
                },
                validators: {
                  cell: {
                    expression: (c) =>
                      validator("cell", c.value, this.validationList),
                    message: (error, field: FormlyFieldConfig) =>
                      errorMessage(
                        field.formControl.value,
                        "cell",
                        this.languageService
                      ),
                  },
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
            ],
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-6",
                key: "telefonoAlternativo",
                defaultValue: "",
                type: "input",
                templateOptions: {
                  label: this.languageService.getValue("telefono_alternativo"),
                  placeholder: this.languageService.getValue(
                    "telefono_alternativo"
                  ),
                },
                validators: {
                  cell: {
                    expression: (c) =>
                      validator("cell", c.value, this.validationList),
                    message: (error, field: FormlyFieldConfig) =>
                      errorMessage(
                        field.formControl.value,
                        "cell",
                        this.languageService
                      ),
                  },
                },
              },
              {
                className: "col-2 my-auto",
                key: "estero",
                type: "sanremo-checkbox",
                defaultValue: false,
                templateOptions: {
                  label: this.languageService.getValue("ed_pr_estero"),
                },
                validators: {
                  estero: {
                    expression: (c) => {
                      let utente = this.form.controls["utente"] as FormGroup;
                      let codiceFiscale = utente.controls["CF"];
                      let provincia = utente.controls["provincia"];
                      let numeroDocumento = utente.controls["numeroDocumento"];

                      let regex: RegExp = getValidatorPattern(
                        "codice_fiscale",
                        this.validationList
                      );

                      if (!c.value) {
                        if (codiceFiscale) {
                          if (regex)
                            codiceFiscale.setValidators([
                              Validators.pattern(regex),
                              Validators.required,
                            ]);
                          else
                            codiceFiscale.setValidators([Validators.required]);

                          codiceFiscale.updateValueAndValidity();
                        }

                        if (provincia) {
                          provincia.setValidators([Validators.required]);
                          provincia.updateValueAndValidity();
                        }

                        if (numeroDocumento) {
                          numeroDocumento.setValidators([Validators.required]);
                          numeroDocumento.updateValueAndValidity();
                        }
                      } else {
                        if (codiceFiscale) {
                          if (regex)
                            codiceFiscale.setValidators([
                              Validators.pattern(regex),
                            ]);
                          else codiceFiscale.clearValidators();
                          codiceFiscale.updateValueAndValidity();
                        }

                        if (provincia) {
                          provincia.clearValidators();
                          provincia.updateValueAndValidity();
                        }

                        if (numeroDocumento) {
                          numeroDocumento.clearValidators();
                          numeroDocumento.updateValueAndValidity();
                        }
                      }
                      return true;
                    },
                  },
                },
              },
              {
                className: "col-md-4",
                key: "idNazione",
                type: "select",
                templateOptions: {
                  required: true,
                  label: this.languageService.getValue("nazione_residenza"),
                  placeholder:
                    this.languageService.getValue("nazione_residenza"),
                  options: this.listaNazioni,
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
            ],
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-md-6",
                key: "indirizzo",
                type: "sanremo-input-lite",
                templateOptions: {
                  required: true,
                  type: "text",
                  label: this.languageService.getValue("indirizzo_principale"),
                  placeholder: this.languageService.getValue(
                    "indirizzo_principale"
                  ),
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-md-6",
                key: "citta",
                type: "sanremo-input-lite",
                templateOptions: {
                  required: true,
                  type: "text",
                  label: this.languageService.getValue("citta"),
                  placeholder: this.languageService.getValue("citta"),
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
            ],
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-md-6",
                key: "provincia",
                type: "sanremo-input-lite",
                templateOptions: {
                  type: "text",
                  label: this.languageService.getValue("provincia"),
                  placeholder: this.languageService.getValue("provincia"),
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-md-6",
                type: "datepicker",
                key: "dataNascita",
                templateOptions: {
                  type: "text",
                  label: this.languageService.getValue("ed_pr_dataNascita"),
                  placeholder: "gg/mm/aaaa",
                  placement: "bottom",
                  bsConfig: {
                    containerClass: "theme-dark-blue",
                  },
                  callback: (event) => this.onSelectedDate(event),
                  required: true,
                },
                validators: {
                  dataNascita: {
                    expression: (c) =>
                      moment(c.value, "DD/MM/YYYY").toDate() <
                      new Date(new Date().setHours(0, 0, 0, 0)),
                    message: (error, field: FormlyFieldConfig) =>
                      this.languageService.getValue("invalid_birthdate"),
                  },
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
            ],
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-md-6",
                key: "luogoNascita",
                type: "sanremo-input-lite",
                templateOptions: {
                  type: "text",
                  label: this.languageService.getValue("ed_pr_luogoNascita"),
                  placeholder:
                    this.languageService.getValue("ed_pr_luogoNascita"),
                  required: true,
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-6",
                key: "CF",
                type: "input",
                templateOptions: {
                  label: this.languageService.getValue("ed_pr_codiceFiscale"),
                  placeholder: this.languageService.getValue(
                    "ed_pr_codiceFiscale"
                  ),
                },
                modelOptions: {
                  updateOn: "blur",
                },
                validators: {
                  CF: {
                    expression: (c) =>
                      validator("codice_fiscale", c.value, this.validationList),
                    message: (error, field: FormlyFieldConfig) =>
                      errorMessage(
                        field.formControl.value,
                        "codice_fiscale",
                        this.languageService
                      ),
                  },
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                    pattern: this.languageService.getValue("invalid_CF"),
                  },
                },
              },
            ],
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-6",
                type: "select",
                key: "idDocumento",
                templateOptions: {
                  label: this.languageService.getValue("documento"),
                  placeholder: this.languageService.getValue("documento"),
                  multiple: false,
                  options: this.listaDocumenti,
                  required: true,
                  change: () => {
                    let utente = this.form.controls["utente"] as FormGroup;
                    let estero = utente.controls["estero"].value;
                    let validators: any[] = [];
                    let numeroDocumento = utente.controls["numeroDocumento"];
                    numeroDocumento.clearValidators();
                    if (!estero) {
                      validators.push(Validators.required);
                    }
                    let tipoDocumento = utente.controls["idDocumento"].value;
                    switch (tipoDocumento) {
                      case "1": {
                        validators.push(
                          Validators.pattern(
                            getValidatorPattern(
                              "numero_documento",
                              this.validationList
                            )
                          )
                        );
                        break;
                      }
                      case "2": {
                        validators.push(
                          Validators.pattern(
                            getValidatorPattern(
                              "numero_passaporto",
                              this.validationList
                            )
                          )
                        );
                        break;
                      }
                      case "3": {
                        validators.push(
                          Validators.pattern(
                            getValidatorPattern(
                              "numero_patente",
                              this.validationList
                            )
                          )
                        );
                        break;
                      }
                    }
                    numeroDocumento.setValidators(validators);
                    numeroDocumento.updateValueAndValidity();
                  },
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
              {
                className: "col-6",
                key: "numeroDocumento",
                type: "input",
                templateOptions: {
                  label: this.languageService.getValue("numero_documento"),
                  placeholder:
                    this.languageService.getValue("numero_documento"),
                },
                modelOptions: {
                  updateOn: "blur",
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                    pattern: this.languageService.getValue(
                      "invalid_document_number"
                    ),
                  },
                },
              },
              {
                className: "col-6 my-auto",
                key: "inMailingList",
                type: "checkbox",
                templateOptions: {
                  label: this.languageService.getValue("inMailingList"),
                  disabled: true,
                },
              },
            ],
          },
          {
            className: "section-label",
            template: `<hr class="mb-0" />
                    <div class="mb-4">
                    <h3>${this.LABEL_ATTACH}</h3>
                    </div>`,
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              {
                className: "col-md-6",
                key: "documento",
                type: "file-input",
                templateOptions: {
                  type: "file",
                  label: this.languageService.getValue("documento_identita"),
                  required: true,
                  callback: (event) => this.onDetectedDocument(event, 0),
                  fileName: null,
                  attributes: {
                    maxSize: 5,
                    extraDesc: "max 5MB, PDF Preferred",
                  },
                },
                validation: {
                  messages: {
                    required:
                      this.languageService.getValue("campo_obbligatorio"),
                  },
                },
              },
            ],
          },
        ],
      },
      {
        fieldGroupClassName: "row justify-content-end",
        fieldGroup: [
          {
            className: "col-md-12",

            key: "recaptcha",
            type: "sanremo-recaptcha",
            templateOptions: {
              siteKey: this.captchaConfiguration.siteKey,
              callback: (event: ReCaptcha2Component, valid: boolean) => {
                this.googlereCaptcha = event;
                this.model.ignoreCaptcha = !valid;
              },
            },
            // expressionProperties: {
            //   "templateOptions.required": "!model.ignoreCaptcha"
            // },
            validation: {
              messages: {
                required: this.languageService.getValue("campo_obbligatorio"),
              },
            },
            wrappers: ["form-field"],
          },
        ],
      },
    ];
  }

  showGDPRModal(): void {
    let response = this.googlereCaptcha.getResponse();
    if (this.form.invalid || !response) {
      checkFormValidity(this.form);
      this.toastrService.error(
        "",
        this.languageService.getValue("errore_form"),
        {
          disableTimeOut: true,
        }
      );
      return;
    }
    this.modalGDPRService.confirm().subscribe((isAccepted: boolean) => {
      if (isAccepted) {
        this.submit(response);
      }
    });
  }

  onSelectedDate(event) {
    let selectedDate: Date = event;
    this.model.dataNascita = this.datepipe.transform(
      new Date(selectedDate),
      "dd/MM/yyyy"
    );
  }

  submit(response: string) {
    this.model.captchaResponse = response;
    this.model.utente.dataRegistrazione = new Date().toISOString();

    this.recordCompanyService
      .createRecordCompanyWithRL(this.model)
      .subscribe((response) => {
        if (response.esito == 0) {
          this.options.resetModel();
          this.toastrService.success(
            null,
            this.languageService.getValue("new_user_created")
          );
          setTimeout(() => {
            this.router.navigate([
              "new-registration/registration-submitted",
              response.tokenSMS,
            ]);
          }, 1000);
        } else {
          this.toastrService.error(null, response.descrizione, {
            disableTimeOut: true,
          });
        }
      });
  }

  annulla() {
    this.router.navigateByUrl("/home-page");
  }

  resetLogo() {
    this.model.casaDiscografica.allegati = null;
    let casaDiscografica = this.form.controls["casaDiscografica"] as FormGroup;
    let logo = casaDiscografica.controls["logo"];
    logo.reset();
    logo.updateValueAndValidity();
  }

}
